import { computeAmount, computePointsAmount } from '@captaincause/lib/amount'
import { formatNumber } from '@captaincause/lib/format'
import { displayImpact } from '@captaincause/lib/impact/computeImpact'
import { tm } from '../tm'
import i18n from './i18n'
import type {
  CampaignProjectResults,
  Locales,
  Project,
} from '@captaincause/types'

interface ProjectImpactConversionProps {
  project: Project | CampaignProjectResults
  pointsMode?: boolean
  locale: Locales
  className?: string
  pointsValueInCents?: number | null
}

export function ProjectImpactConversion({
  project,
  locale,
  pointsMode = false,
  pointsValueInCents = null,
  className = '',
}: ProjectImpactConversionProps) {
  const t = i18n[locale]

  if (!project.action || !project.action.cost || !project.action.num_items) {
    return null
  }

  const amount = pointsMode
    ? `${formatNumber(
        computePointsAmount(project.action.cost, pointsValueInCents),
        locale,
      ).toString()} ${t.points}`
    : computeAmount(project.action.cost, locale)

  return (
    <div className={tm('line-clamp-1 text-xs', className)}>
      {displayImpact({
        action: project.action,
        value: { numItems: project.action.num_items },
        locale,
      })}{' '}
      {' = '}
      {amount}
    </div>
  )
}
